module.exports = __webpack_public_path__ + "static/gmail-e00220b546d7b945d234fcb08dd2d808.png";